import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { LoginModel } from 'src/app/model/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { IFiltroMotoristaModel, IMotoristaModel } from 'src/app/motorista/model/motorista.model';
import { MotoristaService } from 'src/app/motorista/motorista.service';

@Component({
  selector: 'app-pesquisa-motorista',
  templateUrl: './pesquisa-motorista.component.html',
  styleUrls: ['./pesquisa-motorista.component.scss']
})
export class PesquisaMotoristaComponent implements OnInit, OnDestroy {

  usuario !: LoginModel | undefined;

  private subs = new Subscription();

  displayedColumns = ['matricula', 'apelido', 'nome', 'codigo', 'numProduto', 'status'];

  filtro!: IFiltroMotoristaModel;

  public dataSource!: MatTableDataSource<IMotoristaModel>;

  @ViewChild('search', {}) parametroElement!: ElementRef<HTMLInputElement>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  loading = 0;

  constructor(private motoristaService: MotoristaService,
    private authenticationService: AuthenticationService,
    private snackBar: SnackBarService,
    private dialogRef: MatDialogRef<PesquisaMotoristaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.filtro = data.dataKey;
  }

  ngOnInit(): void {

    this.filtro.coluna = "2";
    this.filtro.operador = 4;
    // Liga a animação de Loading (Spinner) na tela 
    this.loading++;
    this.usuario = this.motoristaService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.motoristaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {

          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;

        } else {
          this.filtrar();
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  // ngAfterViewInit() {

  //   setTimeout(()=>{ // this will make the execution after the above boolean has changed
  //     this.parametroElement.nativeElement.focus();
  //   },500);

  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  onSubmit() {
    this.filtrar();
  }

  limpaFiltro() {
    this.filtro.coluna = "2";
    this.filtro.operador = 4;
    this.filtro.parametro = "";
    this.dataSource = new MatTableDataSource<IMotoristaModel>();
  }

  fechar() {
    this.dialogRef.close();
  }

  getRecord(row: IMotoristaModel) {
    this.dialogRef.close({ data: row });
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  private filtrar() {

    this.loading++;

    this.filtro.frota = { codigo: this.motoristaService?.usuario?.retorno?.codigoEntidade };
    this.subs.add(this.motoristaService.listMotorista(this.filtro)
      .subscribe({
        next: (res) => {
          if (res?.sucesso) {
            this.dataSource = new MatTableDataSource<IMotoristaModel>(res.retorno);
            this.dataSource.paginator = this.paginator;
            this.sort.sort(({ id: 'apelido', start: 'asc' }) as MatSortable);
            this.sort.disableClear = true;
            this.dataSource.sort = this.sort;
          }
        },
        complete: () => {
          this.loading--;
        }
      }));
  }

}